import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, LogoutCustom } from "../Components";
import Icon from "../assets/icons/Icon";
import { logoutUser } from "../store/user/user-action";
import { uiActions } from "../store/ui/ui-slice";
import { CommonModal, GlobalSearchModal } from "../Modal";
import { Link } from "react-router-dom";

const Topbar = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { theme } = useSelector((state) => state.ui);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  useEffect(() => {
    if (theme) {
      const root = document.documentElement;
      root.setAttribute("data-bs-theme", theme);
      root.setAttribute("data-startbar", theme);
    }
  }, [theme]);

  const handleTheme = () => {
    const root = document.documentElement;
    const currentTheme = root.getAttribute("data-bs-theme");

    if (currentTheme === "dark") {
      dispatch(uiActions.setTheme("light"));
    } else {
      dispatch(uiActions.setTheme("dark"));
    }
  };

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    if (currentSize && currentSize !== "default") {
      body.setAttribute("data-sidebar-size", "default");
    } else {
      body.setAttribute("data-sidebar-size", "collapsed");
    }
  };

  const handleLogout = async () => {
    await logoutUser(dispatch);
  };

  return (
    <>
      <header className="topbar d-print-none">
        <div className="container-fluid">
          <nav
            className="topbar-custom d-flex justify-content-between"
            id="topbar-custom"
          >
            <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
              <li>
                <Button
                  className="nav-link mobile-menu-btn nav-icon"
                  icon="MdMenu"
                  onClick={handleSideCollapsed}
                />
              </li>
              <li className="logo_icon_img">
                <Link to="/">
                  <img src="/assets/images/dreamz247_logo.png" alt="logo img" />
                </Link>
              </li>
              <li className="hide-phone app-search">
                <form role="search" action="#" method="get">
                  <input
                    type="search"
                    name="search"
                    className="form-control top-search mb-0"
                    placeholder="Search here..."
                    onFocus={(e) => {
                      e.target.blur();
                      setIsShow((prev) => ({
                        ...prev,
                        isOpen: true,
                        rowData: {},
                        name: "add",
                        modalTitle: "search",
                        modalContent: GlobalSearchModal,
                      }));
                    }}
                  />
                  {/* <Icon name="FaSearch" className="iconoir-search" /> */}
                  <Button className="iconoir-search" icon="FaSearch" />
                </form>
              </li>
            </ul>
            <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
              <li className="topbar-item">
                <a className="nav-link nav-icon" href="#" onClick={handleTheme}>
                  {theme === "dark" ? (
                    <Icon name="FaRegMoon" className=" dark-mode" />
                  ) : (
                    <Icon name="FaSun" className="light-mode" />
                  )}
                </a>
              </li>
              <li className="dropdown topbar-item position-relative">
                <LogoutCustom name={user?.username} onClick={handleLogout} />
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleShowHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default memo(Topbar);
